import { DotLottieReact } from "@lottiefiles/dotlottie-react"

const ButtonFrame = ({ handleClick, loading, btnText, classNameStyle }) => {
    return (
        <button onClick={() => handleClick()} disabled={loading} style={{ display:'flex', justifyContent:'center', alignItems: 'center' }} className={classNameStyle}>
            {loading ? (
                <div style={{width: "20px", height:"20px", marginBlock:'auto'}}>
                    <DotLottieReact
                        src="/assets/hatching-chick.json"
                        loop
                        autoplay
                    />
                </div>
            ): btnText}
        </button>
    )
}

export default ButtonFrame;